import { visitorSegments } from "@/pages/admin/dashboard/dashboardData";
import { formatNumber } from "@/pages/admin/format";

export default function VisitorAnalytics() {
  const total = visitorSegments.reduce((sum, segment) => sum + segment.value, 0);
  const newVisitors = 2960;
  const returning = total - newVisitors;

  let acc = 0;
  const stops = visitorSegments
    .map((segment) => {
      const from = acc;
      acc += (segment.value / total) * 100;
      return `${segment.color} ${from}% ${acc}%`;
    })
    .join(", ");

  return (
    <section className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
      <div>
        <h2 className="font-heading text-xl text-foreground-950 font-semibold">Visitor analytics</h2>
        <p className="text-sm text-foreground-600 mt-1">Who's coming to the farms</p>
      </div>

      <div className="flex flex-col sm:flex-row items-center gap-6 mt-6">
        <div className="relative w-40 h-40 shrink-0">
          <div
            className="w-40 h-40 rounded-full"
            style={{ backgroundImage: `conic-gradient(${stops})` }}
          >
            <div className="absolute inset-[18px] rounded-full bg-background-50 flex flex-col items-center justify-center">
              <span className="font-heading text-2xl font-semibold text-foreground-950">
                {formatNumber(total)}
              </span>
              <span className="text-[10px] uppercase tracking-wider text-foreground-500 mt-0.5">
                visitors
              </span>
            </div>
          </div>
        </div>

        <div className="flex-1 w-full space-y-3">
          {[
            { label: "New Visitors", value: newVisitors, chip: "bg-primary-100 text-primary-700" },
            { label: "Returning Visitors", value: returning, chip: "bg-accent-100 text-accent-900" },
          ].map((row) => (
            <div
              key={row.label}
              className={`flex items-center justify-between gap-3 rounded-lg px-4 py-3 ${row.chip}`}
            >
              <span className="text-sm font-medium">{row.label}</span>
              <span className="font-heading text-lg font-semibold">{formatNumber(row.value)}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-6 pt-5 border-t border-background-200 space-y-3">
        {visitorSegments.map((segment) => (
          <div key={segment.label} className="flex items-center gap-3">
            <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: segment.color }}></span>
            <span className="text-sm text-foreground-700 w-24 shrink-0">{segment.label}</span>
            <div className="flex-1 h-2 rounded-full bg-background-100 overflow-hidden">
              <div
                className="h-full rounded-full"
                style={{
                  width: `${Math.max(3, (segment.value / total) * 100)}%`,
                  backgroundColor: segment.color,
                }}
              ></div>
            </div>
            <span className="text-sm font-semibold text-foreground-950 w-14 text-right whitespace-nowrap">
              {formatNumber(segment.value)}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}